import AdminMainContainer from '../../../../layouts/admin/AdminMainContainer'
import { DataGrid } from '@mui/x-data-grid'
import useAdminMedicalReimbursementsUnrespondedPageViewModel from './viewModel'
import { Alert, Box, Button } from '@mui/material'
import RefreshIcon from '@mui/icons-material/Refresh'
import constants from '../../../../constants'
import ApprovalPopup from '../components/ApprovalPopup'

export default function AdminMedicalReimbursementsUnrespondedPage() {
  const viewModel = useAdminMedicalReimbursementsUnrespondedPageViewModel()

  return (
    <AdminMainContainer title='Medical Reimbursements (Unresponded)'>
      <Alert
        severity='info'
        action={
          <Button
            color='inherit'
            size='small'
            startIcon={<RefreshIcon />}
            onClick={() => viewModel.fetchMedicalReimbursementsUnrespondedData()}
          >
            Refresh
          </Button>
        }
        sx={{ mb: 2 }}
      >{`This page only showing latest ${constants.limits.fetchDataCount.sm} data.`}</Alert>
      <Box sx={{ maxWidth: '100%' }}>
        <DataGrid
          showToolbar
          density='compact'
          columns={viewModel.tableData.columns}
          rows={viewModel.tableData.rows}
          loading={viewModel.dataFetchStatus.isLoading}
        />
      </Box>

      <ApprovalPopup onConfirm={viewModel.onApprovalPopupConfirm} />
    </AdminMainContainer>
  )
}
